import { Directive, ElementRef, Input, Renderer, OnInit } from '@angular/core';


@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[droppable]'
})
export class DroppableDirective implements OnInit {


    @Input('drop') drop: (event, ui) => void;
    @Input('over') over: (event, ui) => void; 
    @Input('out') out: (event, ui) => void;
    @Input() accept: string = '.accepted';

    constructor(private el: ElementRef) {

    }

    ngOnInit(): void {
        let self = this;
        $(this.el.nativeElement).droppable({
            accept: this.accept,
            drop: function (event, ui) {
                if (self.drop) {
                    self.drop(event, ui);
                }
            },
            over: function (event, ui) {
                if (self.over) {
                    self.over(event, ui);
                }
            },
            out: function (event, ui) {
                if (self.out) {
                    self.out(event, ui);
                }
            }
        });
    }

}
